<template>
  <q-card
    dark
    class="q-pa-md q-mx-auto text-center shadow-2 rounded-borders"
    style="max-width: 400px;"
  >
    <q-card-section>
      <div class="text-subtitle2 q-mt-xs">
        {{ formattedDate }}
      </div>

      <div class="text-h5 q-mt-sm">
        {{ formattedTime }}
      </div>

      <div v-if="restBetrag" class="text-body1 q-mt-sm">
        {{ restBetrag }}€ bar vor Ort
      </div>
    </q-card-section>
  </q-card>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'
import { DateTime } from 'luxon'

const props = defineProps<{
  startDate: Date
  duration: number
  restBetrag?: number
}>()

// 📅 Formatiertes Datum
const formattedDate = computed(() => {
  return DateTime.fromJSDate(props.startDate).toLocaleString({
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
})

// 🕒 Startzeit + Endzeit aus Dauer berechnen
const formattedTime = computed(() => {
  const start = DateTime.fromJSDate(props.startDate)
  const end = start.plus({ minutes: props.duration })

  const startTime = start.toLocaleString(DateTime.TIME_24_SIMPLE)
  const endTime = end.toLocaleString(DateTime.TIME_24_SIMPLE)

  return `${startTime} – ${endTime} Uhr`
})
</script>

<style scoped>
.rounded-borders {
  border-radius: 16px;
}
</style>
